export const DEFAULT_POST_LOGIN_PATH = "/files";
export const TRIAL_UPLOAD_ONBOARDING_PATH = "/chat";
